export const portfolioData = [{
    title: 'Microsoft Teams Clone',
    filter: ['node'],
    image: './images/projects/TeamsClone.png',
    brief: 'Microsoft teams clone is a video calling web application that allows users to connect with people from anywhere.',
    description: [
        'The project has been a part of the Microsoft Engage 2021 Mentorship program in which the mentees are asked to build the Microsoft Teams Clone with the mandatory functionality - a minimum of two participants should be able to connect with each other and have a video conversation.',
        'Apart from video conferencing, it has mutiple other features like sending text messages to each other, screen-sharing and white board scribbling for a better experience.',
        'It allows creation of unlimited number of unique rooms at one time each having a capacity of atmost ten people. One can also view details of other people as well. At the same time multiple people can also share their screens. One can also pin someone at any time during the meeting.',
    ],
    code: 'https://github.com/AnshikaAgrawal5501/Mircosoft-Teams-Clone',
    demo: 'https://microsoft-teams-clone-5501.herokuapp.com/',
    tech: ['Node.js', 'Express.js', 'EJS', 'Socket.io', 'PeerJS', 'Bootstrap', 'JavaScript', 'Css', 'Html']
}, {
    title: 'Extensify',
    filter: ['react'],
    image: './images/projects/Extensify.png',
    brief: 'Manage all your expenses at one place with the Extensify.',
    description: [
        'Users can login using google accounts and create their own personalised expenses for various dates. They can also update and remove any of their expense any time. Filtering depdending upon certain characters present in the title, sort by date and amount and extracting out the expenses lying in a specific date range.',
        'Google authentication is used for login to the application that is done using firebase. Also the all the data gets stored in the firbase realtime database.'
    ],
    code: 'https://github.com/AnshikaAgrawal5501/Extensify-App',
    demo: 'https://extensify-app.netlify.app/',
    tech: ['React.js', 'Firebase', 'Redux', 'Material Ui', 'Bootstrap', 'JavaScript', 'Sass', 'JSX']
}, {
    title: 'Task Manager Api',
    filter: ['backend', 'node'],
    image: './images/projects/TaskManager.jpg',
    brief: 'Task Manager will help you manage all your tasks at one place.',
    description: [
        'Users can create profiles using a mail id and password. For authentication Jwt tokens are used. After signup a welcome mail will be sent to them and passwords are stored in mongodb database in bcrypt manner only.',
        'Users can login from as many devices as they wish and can also logout from all of them at the same time from one single place. One can also delete or close their account/profile and a goodbye mail will be sent to them.',
        'User can update their usenames, avatars and can create, update, or delete their tasks. There is also a feature for the filtering of tasks depending upon different criterias.',
        'This is only an api that either equires a frontend or it can be tested using postman or any other API platforms.'
    ],
    code: 'https://github.com/AnshikaAgrawal5501/Task-Manager-API',
    demo: '',
    tech: ['Express', 'Node.js', 'MongoDb', 'Nodemailer', 'JWT']
}, {
    title: 'Pokedex',
    filter: ['react'],
    image: './images/projects/Pokedex.png',
    brief: 'Pokedex is a react based web application that displays information of all the pokemons.',
    description: [
        'The application fetches the data of all the pokemons from an api called pokeapi. It not only displays all the pokemons but also allows filtering based on the search.',
    ],
    code: 'https://github.com/AnshikaAgrawal5501/Pokedex',
    demo: 'https://pokedex-anshika5501.netlify.app/',
    tech: ['React.js', 'Material Ui', 'Redux', 'Bootstrap', 'JavaScript', 'Sass', 'JSX']
}, {
    title: 'JavaScript Collection',
    filter: ['react', 'javascript'],
    image: './images/projects/JavaScriptCollection.png',
    brief: 'Collection of all my javascript projects that I have built so far.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/JavaScript-Collection',
    demo: 'https://javascript-collection.netlify.app/',
    tech: ['React.js', 'Material Ui', 'Bootstrap', 'JavaScript', 'Css', 'Html']
}, {
    title: 'Zippy Website',
    filter: ['bootstrap'],
    image: './images/projects/Zippy.png',
    brief: 'Simple web page demonstrating the usage of vaiorus bootstrap components.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/Zippy-Website',
    demo: 'https://anshikaagrawal5501.github.io/Zippy-Website/',
    tech: ['Bootstrap', 'JavaScript', 'Css', 'Html']
}, {
    title: 'Femaissance',
    filter: ['mern'],
    image: './images/projects/Femaissance.png',
    brief: 'A common platform to bring women together suffering from postpartum depression or loneliness or other issues during pregnancy.',
    description: [
        'This website was built during Hack4Women hackathon(12 hours hackathon) where we had to come up with a solution for women in rural and urban area. It was built to connect the gynaecologist ,physiologist and the people who have expertise in those fields, to the pregnant women, who are dealing with mental depression.',
        'We in a team of 5 people have built this project in which my contributions include the frontend part.',
        'This platform would give freedom to its users to post ,like, comment and share to increase awareness among all womens. Language switching feature is also available.'
    ],
    code: 'https://github.com/jaydip1235/hack4women',
    demo: 'https://femaissance.netlify.app/',
    tech: ['React.js', 'Express', 'Node.js', 'MongoDb', 'Material Ui', 'Bootstrap', 'JavaScript', 'Scss', 'JSX']
}, {
    title: 'Sugam',
    filter: ['mern'],
    image: './images/projects/Sugam.png',
    brief: 'A slot booking website that allows the ration distributors to create slots for the people to avoid the chaos in front of their shops, such that people will come at a specific time chosen by them.',
    description: [
        'This website was built during Ion<athon> 1.0 hackathon where we participated as a team of 2 members and build the project under the theme Social Service. The motive is to come up with a solution which will impact the life of under priviledged people.',
        `There are two portals present - Ditributor and User. Distributors will select a date and then a time range during which they will open the shop, slots will get created of 1 hour each in the range each having limit of 10 people. 
        Now users/people will be able to see only the dates when there are time slots availabe created by their respective ditributos only.
        After booking a slot the user data will be seen by the distributor who while giving ration will check the time slot and then mark done.`,
        'For authentication we have used firebase auth with phone number verification. And for data storage mongodb is used. Slot receipts will be send to the corresponding phone no. using vonage api. The backend is deployed on Heroku and frontend is deployed on Netlify.',
    ],
    code: 'https://github.com/DevToons/Sugam',
    demo: 'https://sugam-frontend.netlify.app/',
    tech: ['React.js', 'Express', 'Node.js', 'MongoDb', 'Firebase', 'Material Ui', 'Bootstrap', 'JavaScript', 'Scss', 'JSX']
}, {
    title: 'Girl Code It Website',
    filter: ['bootstrap'],
    image: './images/projects/GirlCodeIt.png',
    brief: 'This is an unofficial website of the Girl Code It community. ',
    description: [
        'Girl Code It aka GCI is a collaborative effort to build a healthy coding culture among young coders and to encourage them to kickstart their journey incoding and development.',
        'This website is made as a part of one of the modules of frontend web development.',
    ],
    code: 'https://github.com/AnshikaAgrawal5501/Girl-Code-It-2',
    demo: 'https://anshikaagrawal5501.github.io/Girl-Code-It-2/',
    tech: ['Bootstrap', 'Css', 'Html']
}, {
    title: 'User Info App',
    filter: ['react'],
    image: './images/projects/UserInfoApp.png',
    brief: 'User Info is a simple web page that fetches data of certain people from an api.',
    description: [
        'It is created to demonstrate the usage of simple react components and fetching data from an api in react. ',
    ],
    code: 'https://github.com/AnshikaAgrawal5501/UserInfo-React-App',
    demo: 'https://userinfo-react-app-anshika5501.netlify.app/',
    tech: ['React.js', 'Material Ui', 'Reactstrap', 'Bootstrap', 'JavaScript', 'Css', 'Html']
}, {
    title: 'Weather App',
    filter: ['node'],
    image: './images/projects/WeatherApp.png',
    brief: 'A web app that displays weather conditions of different areas that are fetched using Open Weather Api.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/Weather-App',
    demo: 'https://shrouded-plateau-48102.herokuapp.com/',
    tech: ['Node.js', 'Express.js', 'EJS', 'Bootstrap', 'JavaScript', 'Css', 'Html']
}, {
    title: 'Ice Cream Shop Website',
    filter: ['bootstrap'],
    image: './images/projects/IceCreamShop.png',
    brief: 'Simple web page demonstrating the usage of various boostrap components and classes.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/Ice-Cream-Shop-Webpage',
    demo: 'https://anshikaagrawal5501.github.io/Ice-Cream-Shop-Webpage/',
    tech: ['Bootstrap', 'Css', 'Html']
}, {
    title: 'Keeper App',
    filter: ['react'],
    image: './images/projects/KeeperApp.png',
    brief: 'A keeper of all your notes that get stored in the local storage of the browser.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/Keeper-App',
    demo: 'https://keeper-app-anshika5501.netlify.app/',
    tech: ['React.js', 'Material Ui', 'Css', 'JSX']
}, {
    title: 'Newsletter Signup App',
    filter: ['node'],
    image: './images/projects/NewsletterSignup.png',
    brief: 'Subscribe to the newsletter by entering name and email id created using MailChimp service.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/Newsletter-Signup-App',
    demo: 'https://glacial-everglades-48617.herokuapp.com/',
    tech: ['Node.js', 'Express.js', 'EJS', 'Bootstrap', 'JavaScript', 'Css', 'Html']
}, {
    title: 'W3 Newbie Website',
    filter: ['bootstrap'],
    image: './images/projects/W3Newbie.png',
    brief: 'Simple web page demonstrating the usage of various boostrap components and classes.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/w3-newbie-website',
    demo: 'https://anshikaagrawal5501.github.io/w3-newbie-website/',
    tech: ['Bootstrap', 'Css', 'Html']
}, {
    title: 'Blog Website',
    filter: ['node'],
    image: './images/projects/BlogWebsite.png',
    brief: 'A blog creating website where one can create blogs and search for a specific one. Created to learn the basics of express and nodejs.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/Blog-Website',
    demo: 'https://calm-headland-01767.herokuapp.com/',
    tech: ['Node.js', 'Express.js', 'EJS', 'Bootstrap', 'JavaScript', 'Css', 'Html']
}, {
    title: 'UI Website',
    filter: ['bootstrap'],
    image: './images/projects/UiWebsite.png',
    brief: 'Simple web page demonstrating the usage of various boostrap components and classes.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/UI-Website',
    demo: 'https://anshikaagrawal5501.github.io/UI-Website/',
    tech: ['Bootstrap', 'Css', 'Html']
}, {
    title: 'TinDog Website',
    filter: ['bootstrap'],
    image: './images/projects/TinDog.png',
    brief: 'Simple web page demonstrating the usage of various boostrap components and classes.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/TinDog',
    demo: 'https://anshikaagrawal5501.github.io/TinDog/',
    tech: ['Bootstrap', 'Css', 'Html']
}, {
    title: 'ConFusion Website',
    filter: ['bootstrap'],
    image: './images/projects/ConfusionBootstrap.png',
    brief: 'Simple web page demonstrating the usage of various boostrap components and classes.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/conFusion',
    demo: 'https://anshikaagrawal5501.github.io/conFusion/',
    tech: ['Bootstrap', 'Css', 'Html']
}, {
    title: 'Developer Portfolio Website',
    filter: ['bootstrap'],
    image: './images/projects/DeveloperPortfolio.png',
    brief: 'Simple web page demonstrating the usage of various boostrap components and classes.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/Developer-Portfolio-Website',
    demo: 'https://anshikaagrawal5501.github.io/Developer-Portfolio-Website/',
    tech: ['Bootstrap', 'Css', 'Html']
}, {
    title: 'ToDo using React',
    filter: ['react'],
    image: './images/projects/TodoReact.png',
    brief: 'Simple todo list that allows creation of tasks, check them and delete them. Created to learn the basics of react.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/To-Do-List-using-React',
    demo: 'https://to-do-react-anshika5501.netlify.app/',
    tech: ['React.js', 'JavaScript', 'Css', 'JSX']
}, {
    title: 'ToDo List',
    filter: ['node'],
    image: './images/projects/Todo.png',
    brief: 'Simple todo list that allows creation of tasks, check them and delete them. To store the data Mongodb is used. Created to learn the basics of express and nodejs.',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/Todo-List-App-v2',
    demo: 'https://arcane-cliffs-28813.herokuapp.com/',
    tech: ['Node.js', 'Express.js', 'MongoDb', 'EJS', 'JavaScript', 'Bootstrap', 'Css', 'Html']
}, {
    title: 'Notes App CLI',
    filter: ['cli'],
    image: './images/projects/NotesAppCli.webp',
    brief: 'A cli tool that is used to keep notes and store the data in json format in a file. One can add delete list out and read any note. Chalk is used to used to display data in colorful format',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/Todo-List-App-v2',
    demo: 'https://arcane-cliffs-28813.herokuapp.com/',
    tech: ['Node.js', 'Yargs', 'JavaScript']
}, {
    title: 'Weather App CLI',
    filter: ['cli'],
    image: './images/projects/WeatherAppCli.png',
    brief: 'A cli tool that takes in a location as a parameter and displayes the weather conidtions using the Accuweather APIs',
    description: [],
    code: 'https://github.com/AnshikaAgrawal5501/Todo-List-App-v2',
    demo: 'https://arcane-cliffs-28813.herokuapp.com/',
    tech: ['Node.js', 'Yargs', 'JavaScript']
}, ];